"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get default () {
        return _default;
    },
    get swaggerV3 () {
        return _swaggerv3json;
    },
    get swaggerV3Validation () {
        return swaggerV3Validation;
    }
});
const _deepClone = /*#__PURE__*/ _interop_require_default(require("src/helpers/deepClone"));
const _swaggerv3validationpatchjson = /*#__PURE__*/ _interop_require_wildcard(require("./swagger-v3-validation-patch.json"));
const _swaggerv3json = /*#__PURE__*/ _interop_require_wildcard(require("./swagger-v3.json"));
const _swaggerjson = /*#__PURE__*/ _interop_require_wildcard(require("./swagger.json"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const _default = _extends({}, _swaggerjson, {
    components: _extends({}, _swaggerjson.components, {
        schemas: _extends({}, _swaggerjson.components.schemas, _swaggerv3json.components.schemas)
    })
});
const swaggerV3Validation = (0, _deepClone.default)(_swaggerv3json);
for (const [key, value] of Object.entries(_swaggerv3validationpatchjson.components.schemas)){
    swaggerV3Validation.components.schemas[key] = value;
}
